import React, { FC } from "react";

import { Status } from "@/components/atoms";
import { StatusColorType } from "@/components/atoms/Status/styled";

import {
    FeatureItem,
    FeatureItemProps,
    LabelValue,
    LabelValueProps,
    PaymentItem,
    PaymentItemProps,
} from "./components";

export type IsStatusInfoType = {
    key: string;
    isStatus: boolean;
    value: string;
    color: StatusColorType;
};

type InfoItemMultipleType = {
    key: string;
    label?: string;
    features?: FeatureItemProps[];
    payments?: PaymentItemProps[];
    values?: LabelValueProps[];
};

export type InfoItemProps = LabelValueProps | InfoItemMultipleType | IsStatusInfoType;

const InfoItem: FC<InfoItemProps> = (props) => {
    if ("isStatus" in props && props.isStatus) {
        const { value, color } = props;
        return <Status color={color} text={value} />;
    }

    const hasMultipleValues =
        ("payments" in props && !!props.payments.length) ||
        ("features" in props && !!props.features.length) ||
        ("values" in props && !!props.values.length);

    if (!hasMultipleValues) {
        return <LabelValue {...(props as LabelValueProps)} />;
    }

    const { label, features = [], payments = [], values = [] } = props;

    const renderPaymentList = payments.map((paymentItem, i) => <PaymentItem {...paymentItem} index={i} />);
    const renderFeatureList = features.map((featureItem) => <FeatureItem {...featureItem} />);
    const renderLabelValueList = values.map((item) => <LabelValue {...item} />);

    return (
        <>
            <div className="infoContainer">
                <span className="labelPanelSection">{label}</span>
            </div>
            {!!payments.length && renderPaymentList}
            {!!features.length && (
                <div className="infoContainer">
                    <div className="featuresContainer">{renderFeatureList}</div>
                </div>
            )}
            {!!values.length && <div className="valuesContainer">{renderLabelValueList}</div>}
        </>
    );
};

export default InfoItem;
